export const SAVE = 'disasterAssistanceHardshipStep.SAVE';
export const VALUE_CHANGED = 'disasterAssistanceHardshipStep.VALUE_CHANGED';
export const LOAD = 'disasterAssistanceHardshipStep.VALUE_LOAD';
export const NEXT = 'disasterAssistanceHardshipStep.NEXT';
export const RESET = 'disasterAssistanceHardshipStep.RESET';
export const RESET_DAMAGED_LOST_EXPENSE = 'disasterAssistanceHardshipStep.RESET_DAMAGED_LOST_EXPENSE';
export const RESET_DELAYED_LUGGAGE_EXPENSE = 'disasterAssistanceHardshipStep.RESET_DELAYED_LUGGAGE_EXPENSE';
export const RESET_COMPENSATION = 'disasterAssistanceHardshipStep.RESET_COMPENSATION';
//-------------------------------------------------------
export const RESET_TRIP_CANCELLATION_STATE = 'disasterAssistanceHardshipStep.RESET_TRIP_CANCELLATION_STATE';
export const RESET_TRAVEL_INTERRUPTION_STATE = 'disasterAssistanceHardshipStep.RESET_TRAVEL_INTERRUPTION_STATE';
export const RESET_TRAVEL_DELAY_STATE = 'disasterAssistanceHardshipStep.RESET_TRAVEL_DELAY_STATE';
//------------------------------------------------------
export const RESET_FOR_DAMAGE_LOST_OR_STOLEN_LUGGAGE_STATE = 'disasterAssistanceHardshipStep.RESET_FOR_DAMAGE_LOST_OR_STOLEN_LUGGAGE_STATE';
export const RESET_FOR_BAGGAGE_DELAY_STATE = 'disasterAssistanceHardshipStep.RESET_TRAVEL_INTERRUPTION_STATE';
export const RESET_EUROPEAN_UNION_STATE = 'disasterAssistanceHardshipStep.RESET_EUROPEAN_UNION_STATE';

export const REPORT_TO = {
  POLICE: '1',
  HOTEL_MANAGEMENT: '2',
  CRUISE_SHIP: '3',
  AIRLINE: '4',
  TOUR_GUIDE: '5',
  OTHER: '6',
  NOT_REPORT: '20',
};

export const CLAIMING_FOR = {
  PASSPORT_CREDIT_CARD: 'claimForPassportCreditCard',
  THEFT_OF_CASH: 'claimForTheftOfCash',
  LUGGAGE_AND_PERSONAL_EFFECTS: 'claimForLuggageAndPersonalEffect',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.DuesProtect.DisasterAssistanceHardshipStep/constants.js